/* eslint-disable no-new */
/* eslint-disable no-unused-vars */

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Components from './components'
import router from './router'
import Meta from 'vue-meta'
import VueScrollTo from 'vue-scrollto'
import VueStripeCheckout from 'vue-stripe-checkout'

import './stylesheets/app.scss'

Vue.use(Meta)
Vue.use(VueScrollTo)

const StripeCheckoutOptions = {
  key: 'pk_live_JrCKVssPNwFTp3MW7GROoIAO',
  // key: 'pk_test_p5tIIj7Nt7j7vdVKpEnGD2qG', // Test
  name: 'Taiko Trust',
  locale: 'auto',
  currency: 'NZD',
  billingAddress: true,
  zipCode: true,
  panelLabel: 'Donate'
}

Vue.use(VueStripeCheckout, StripeCheckoutOptions)

Vue.config.productionTip = false

new Vue({
  el: '#app',
  delimiters: ['${', '}'],
  router
})



// WEBPACK FOOTER //
// ./src/main.js